
import Vue from 'vue';
import App from './App.vue';

import router from "./router.js";
import store from './store.js';
import './common/all.css';

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

import './icons';
import '@/permission';

import axios from 'axios';

Vue.config.productionTip = false;

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  //ak: 'V465HCK0WVe3FeGl0N6smTNEesctANAD'
  //ak: 'U0JfWMkzIxo3tm92p7r2Ipsr9amQCTuG'//person
  ak: 'rwgbN9UsKt62K7n22XivKIHxjG1FqtDB'//person
})

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import VCharts from 'v-charts'
Vue.use(VCharts);


import Print from "vue-print-nb";
Vue.use(Print);

//全局注册，使用方法为:this.$axios
Vue.prototype.$axios = axios;




// release


//http
// Vue.prototype.$shopUrl = "http://111.231.11.44:9987/";
// Vue.prototype.$websocketUrl = "ws://111.231.11.44:9987/websocket/";
// Vue.prototype.$deviceUrl = "http://111.231.11.44:50001/";
// Vue.prototype.$imgUrl = "http://111.231.11.44:83/";
// Vue.prototype.$visualUrl = "http://111.231.11.44:82/";


//https
Vue.prototype.$shopUrl = "https://adm.xxkangyang.com:50007/";
Vue.prototype.$websocketUrl = "wss://adm.xxkangyang.com:50007/websocket/";
Vue.prototype.$deviceUrl = "https://adm.xxkangyang.com:50008/";
Vue.prototype.$imgUrl = "https://adm.xxkangyang.com:447/";
Vue.prototype.$visualUrl = "https://adm.xxkangyang.com:448/";


Vue.prototype.$signKey = "ED139FA9132F1E60967C8579D1F7B958";



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
